import * as React from 'react';
import { UnifiedPayee } from '@mortee/domain/morteeAccountVerificationUnifiedPayee';
import BasePayeeSearchInput from './BasePayeeSearchInput';

interface KnoxOrTaxIdSearchInputProps {
  placeholder?: string;
  onPayeeSelected: (payee: UnifiedPayee) => void;
  value?: string;
  onValueChange?: (value: string) => void;
  onManualEditAfterSelection?: () => void;
  className?: string;
  inputClassName?: string;
  searchCondition?: (query: string) => boolean;
}

const KnoxOrTaxIdSearchInput = React.forwardRef<HTMLInputElement, KnoxOrTaxIdSearchInputProps>(
  (
    {
      placeholder = 'Search by Knox ID or Tax ID',
      onPayeeSelected,
      value,
      onValueChange,
      onManualEditAfterSelection,
      className,
      inputClassName,
      searchCondition,
    },
    ref,
  ) => {
    const getDisplayValue = (payee: UnifiedPayee): string => {
      const { KnoxId, TaxId } = payee.strongLegalIdentifies ?? {};
      return KnoxId?.[0]?.value || TaxId?.[0]?.value || '';
    };

    return (
      <BasePayeeSearchInput
        ref={ref}
        id='knox-or-tax-id-search-input'
        onPayeeSelected={onPayeeSelected}
        value={value}
        onValueChange={onValueChange}
        onManualEditAfterSelection={onManualEditAfterSelection}
        placeholder={placeholder}
        className={className}
        inputClassName={inputClassName}
        getDisplayValueForSelectedPayee={getDisplayValue}
        searchCondition={searchCondition}
      />
    );
  },
);

KnoxOrTaxIdSearchInput.displayName = 'KnoxOrTaxIdSearchInput';

export default KnoxOrTaxIdSearchInput;
